(function(){
  function ready(fn){
    if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fn);}else{fn();}
  }

  function initReveal(){
    var cards=[].slice.call(document.querySelectorAll('.sb-reveal'));
    if(!cards.length){return;}
    cards.forEach(function(card,index){card.style.setProperty('--sb-reveal-delay', Math.min(index % 10, 9) * 70 + 'ms');});
    if(!('IntersectionObserver' in window)){
      cards.forEach(function(card){card.classList.add('is-visible');});
      return;
    }
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },{threshold:0.14,rootMargin:'0px 0px -40px 0px'});
    cards.forEach(function(card){observer.observe(card);});
  }

  function initProductGalleries(){
    document.querySelectorAll('[data-product-gallery]').forEach(function(gallery){
      var slides=[].slice.call(gallery.querySelectorAll('[data-product-slide]'));
      var thumbs=[].slice.call(gallery.querySelectorAll('[data-product-thumb]'));
      var current=gallery.querySelector('[data-product-current]');
      var prev=gallery.querySelector('[data-product-prev]');
      var next=gallery.querySelector('[data-product-next]');
      if(!slides.length){return;}
      var active=0;
      function show(index){
        active=(index+slides.length)%slides.length;
        slides.forEach(function(slide,i){
          slide.classList.toggle('is-active',i===active);
        });
        thumbs.forEach(function(thumb,i){
          thumb.classList.toggle('is-active',i===active);
          if(i===active){thumb.setAttribute('aria-current','true');}else{thumb.removeAttribute('aria-current');}
        });
        if(current){current.textContent=String(active+1);}
      }
      thumbs.forEach(function(thumb){
        thumb.addEventListener('click',function(){
          var nextIndex=parseInt(thumb.getAttribute('data-product-thumb'),10);
          if(isNaN(nextIndex)){nextIndex=0;}
          show(nextIndex);
        });
      });
      if(prev){prev.addEventListener('click',function(){show(active-1);});}
      if(next){next.addEventListener('click',function(){show(active+1);});}
      show(0);
    });
  }

  function initQtyControls(){
    document.querySelectorAll('[data-qty-control]').forEach(function(control){
      var input=control.querySelector('input');
      var minus=control.querySelector('[data-qty-minus]');
      var plus=control.querySelector('[data-qty-plus]');
      if(!input){return;}
      function setQty(next){
        var value=parseInt(input.value,10);
        if(isNaN(value)){value=1;}
        value=value+next;
        if(value<1){value=1;}
        input.value=String(value);
        input.dispatchEvent(new Event('change',{bubbles:true}));
      }
      if(minus){minus.addEventListener('click',function(){setQty(-1);});}
      if(plus){plus.addEventListener('click',function(){setQty(1);});}
    });
  }

  ready(function(){
    initReveal();
    initProductGalleries();
    initQtyControls();
  });
})();
